import {Routes} from '@angular/router';

export const appRoutes: Routes = [
  {
    path: 'sessions',
    loadChildren: './views/sessions/sessions.module#SessionsModule',
    data: {title: 'Sessions'}
  },
  {
    path: '',
    loadChildren: './views/public/public.module#PublicModule',
    data: {title: 'Home'}
  }
];



// WEBPACK FOOTER //
// ./src/app/app-routes.ts